import Vue from 'vue';

export default function() {
  const EventBus = new Vue();

  Object.defineProperties(Vue.prototype, {
    $bus: {
      get() {
        return EventBus;
      },
    },
  });
}
